import React, {useContext} from 'react';
import './Settings.less';
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {SettingsGeneral} from "compositions/settings-general/SettingsGeneral";
import {SettingsFooter} from "compositions/settings-footer/SettingsFooter";
import {Block} from "compositions/block/Block.tsx";
import {Card} from "elements/card/Card.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {CardStyles} from "../../elements/card/Card";
import {isPWAInstallAvailable} from "../../../helpers/pwa-helper";
import {Button} from "../../elements/button/Button";
import Platform from '../../../platform';

export const SETTINGS_POPUP = 'SETTINGS_POPUP';

export const Settings = ({
													 isShowLogout,
													 termsUrl,
													 appVersion,
													 language,
													 activeNotificationsCount,
													 onLanguageClick,
													 onNotificationClick,
													 onLogoutClick,
													 onVersionClick,
													 onOverlayClick
												 }) => {

	const translations = useContext(TranslationsContext);

	return <PseudoPagePopup
		title={getSafeTranslation('SettingsPopup.title', translations)}
		onBackClick={onOverlayClick}
	>
		<div className="settings">
			<div className="settings__general">
				<Block
					title={getSafeTranslation('SettingsPopup.generalBlockTitle', translations)}
					isNonScalable
				>
					<Card style={CardStyles.NESTED} isNoPaddings>
						<SettingsGeneral
							currentLanguage={language}
							notificationCount={activeNotificationsCount}
							onLanguageClick={onLanguageClick}
							onNotificationClick={onNotificationClick}
						/>
					</Card>
				</Block>
			</div>
			<div className="settings__footer">
				<SettingsFooter
					isShowLogout={isShowLogout}
					onLogoutClick={onLogoutClick}
					termsUrl={termsUrl}
					version={appVersion}
					acti
					onVersionClick={onVersionClick}
				/>
			</div>
		</div>
	</PseudoPagePopup>
}
